/** 待支付订单 status */
export const ORDER_STATUS_PENDING_PAY = 5;

/** 从订单项解析支付截止时间（毫秒时间戳，越小越紧急） */
export function getOrderPayDeadlineMs(item, now = Date.now()) {
    if (!item || Number(item.status) !== ORDER_STATUS_PENDING_PAY)
        return Infinity;
    const r = Number(item.remainTime);
    if (Number.isFinite(r) && r > 0) {
        const remainMs = r >= 1e3 ? r : r * 1e3;
        return now + remainMs;
    }
    const ct = Number(item.createTime ?? item.time);
    if (Number.isFinite(ct) && ct > 0) {
        const ctMs = ct < 1e12 ? ct * 1e3 : ct;
        return ctMs + 3 * 60 * 1e3;
    }
    return Infinity;
}

/** 订单金额（元） */
export function getOrderAmountYuan(item) {
    const v = item?.amount ?? item?.originalAmount ?? item?.price ?? item?.totalPrice;
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
}

export function getOrderDisplayName(item) {
    return String(
        item?.goodsName || item?.blindName || item?.productName || item?.nftName || item?.name || item?.orderId || ""
    ).trim();
}
